module.exports = __webpack_public_path__ + "assets/img/aboutus_img__colorsystem_1.770aaf4e.svg";